<template>
    <tr :class="{'disabled':isSubmitting}">
        <td>
            <button v-if="canEdit" :disabled="isSubmitting" @click="onDelete()" class="btn btn-danger btn-sm" type="button"><i
                    class="fa fa-trash"></i>Delete
            </button>
        </td>
        <td>{{personOrganizationRole.organizationRoleName}}</td>
        <td>{{personOrganizationRole.personName}}</td>
        <td>{{personOrganizationRole.personEmploymentStatus}}</td>
        <td>{{personOrganizationRole.organizationCode}}</td>
        <td class="text-center">
            <AppCheckBox :disabled="isSubmitting || !canEdit || !canSetPrimaryContact"
                         @change="canEdit ? onUpdate() : null"
                         v-model="personOrganizationRole.isPrimaryContact"/>
        </td>
    </tr>
</template>

<script>
    import OrganizationService from "../../services/OrganizationService";
    import AppCheckBox from "@/components/shared/AppCheckBox";
    import {ToastType} from "@/services/models/shared/ToastType";
    import {ApplicationRole} from "@/services/models/Role";

    export default {
        components: {
            AppCheckBox
        },
        data() {
            return {
                isSubmitting: false
            }
        },
        props: {
            personOrganizationRole: {
                required: true
            },
            roleList: {
                required: true,
                type: Array
            }
        },
        computed: {
            /**
             * @description Indicates if this form can be edited by the person based on the given role
             * @returns {boolean}
             */
            canEdit() {
                return this.hasApplicationRole(ApplicationRole.DatabaseAdministrator, ApplicationRole.Business, ApplicationRole.TTIWebsiteAdministrator) && this.personOrganizationRole.organizationRoleId.toUpperCase() !== '590E123D-559E-49D1-B890-75286DE55BAD';
            },

            /**
             * @description Indicates if the is primary contact checkbox can be selected for the given role
             * @returns {boolean}
             */
            canSetPrimaryContact() {
                return this.personOrganizationRole.isPrimaryContact || (this.roleList.find(x => x.id !== this.personOrganizationRole.id && x.organizationRoleId.toUpperCase() === this.personOrganizationRole.organizationRoleId.toUpperCase() && x.isPrimaryContact) === undefined)
            }
        },
        methods: {
            /**
             * @description Emits the delete event to the parent component
             */
            onDelete() {
                if (!this.canEdit)
                    return;

                this.$emit('delete',
                    this.personOrganizationRole,
                )
            },

            /**
             * @description Updates the role and posts the event to the parent component
             */
            onUpdate() {
                if (!this.canEdit || !this.canSetPrimaryContact)
                    return;

                const vm = this;

                // Toggle the value
                vm.isSubmitting = true;
                OrganizationService.updateOrganizationRole(this.personOrganizationRole).then(() => {
                    vm.alert(ToastType.Success, `The ${vm.personOrganizationRole.organizationRoleName} role was successfully updated.`)
                }).catch(error => {
                    vm.alert(ToastType.Danger, error.response.statusText)
                }).finally(() => {
                    vm.isSubmitting = false;

                    // Emit the event to the parent
                    vm.$emit('update', vm.personOrganizationRole);
                });
            }
        }
    }
</script>
